export default function hasDuplicates(array: Array<any>) {
  const stringifiedArray = array.map((index) => JSON.stringify(index));
  return (new Set(stringifiedArray)).size !== stringifiedArray.length;
}
